// @ts-nocheck

/**
 * * `adventure` - Adventure
 * `bedtime` - Bedtime
 * `educational` - Educational
 * `friendship` - Friendship
 * `family` - Family
 * `fantasy` - Fantasy
 * `seasonal` - Seasonal
 * `custom` - Custom
 */
export type Category233Enum =
  typeof Category233Enum[keyof typeof Category233Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Category233Enum = {
  adventure: "adventure",
  bedtime: "bedtime",
  educational: "educational",
  friendship: "friendship",
  family: "family",
  fantasy: "fantasy",
  seasonal: "seasonal",
  custom: "custom",
} as const;
